"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
    const body = document.body;
    if (!mobileMenuToggle || !mobileMenu || !mobileMenuOverlay) {
        return;
    }
    // Toggle mobile menu
    function toggleMobileMenu() {
        const isActive = mobileMenuToggle.classList.contains('active');
        if (isActive) {
            closeMobileMenu();
        }
        else {
            openMobileMenu();
        }
    }
    // Open mobile menu
    function openMobileMenu() {
        mobileMenuToggle.classList.add('active');
        mobileMenu.classList.add('active');
        mobileMenuOverlay.classList.add('active');
        body.classList.add('mobile-menu-open');
    }
    // Close mobile menu
    function closeMobileMenu() {
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        body.classList.remove('mobile-menu-open');
    }
    // Event listeners
    mobileMenuToggle.addEventListener('click', toggleMobileMenu);
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    // Close menu when clicking on menu links
    const mobileMenuLinks = mobileMenu.querySelectorAll('a');
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', closeMobileMenu);
    });
    // Close menu with Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
            closeMobileMenu();
        }
    });
    // Close menu on window resize if screen becomes desktop size
    window.addEventListener('resize', function () {
        if (window.innerWidth > 1024 && mobileMenu.classList.contains('active')) {
            closeMobileMenu();
        }
    });
});

"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('informationSlider');
    const prevButton = document.getElementById('prevInfoSlide');
    const nextButton = document.getElementById('nextInfoSlide');
    const currentSlideSpan = document.querySelector('.information-items-slider .current-slide');
    if (!slider || !prevButton || !nextButton || !currentSlideSpan) {
        return;
    }
    const slides = slider.querySelectorAll('.slide');
    const totalSlides = slides.length;
    let currentSlide = 0;
    // Update slide indicator
    function updateSlideIndicator() {
        if (currentSlideSpan) {
            currentSlideSpan.textContent = (currentSlide + 1).toString();
        }
    }
    // Show specific slide using transform
    function showSlide(index) {
        // Calculate the transform value
        const translateX = -index * 100;
        // Apply transform to the slider container
        slider.style.transform = `translateX(${translateX}%)`;
        // Update slide indicator
        updateSlideIndicator();
        // Update button states
        updateButtonStates();
    }
    // Update button states
    function updateButtonStates() {
        if (prevButton && nextButton) {
            prevButton.disabled = currentSlide === 0;
            nextButton.disabled = currentSlide === totalSlides - 1;
        }
    }
    // Go to next slide
    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            currentSlide++;
            showSlide(currentSlide);
        }
    }
    // Go to previous slide
    function prevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            showSlide(currentSlide);
        }
    }
    // Event listeners
    nextButton.addEventListener('click', nextSlide);
    prevButton.addEventListener('click', prevSlide);
    // Touch/swipe support
    let startX = 0;
    let endX = 0;
    slider.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
    });
    slider.addEventListener('touchend', function (e) {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
    });
    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = startX - endX;
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                // Swiped left - next slide
                nextSlide();
            }
            else {
                // Swiped right - previous slide
                prevSlide();
            }
        }
    }
    // Initialize
    showSlide(currentSlide);
});

"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('leaderboardSlider');
    const prevButton = document.getElementById('prevSlide');
    const nextButton = document.getElementById('nextSlide');
    const currentSlideSpan = document.querySelector('.current-slide');
    if (!slider || !prevButton || !nextButton || !currentSlideSpan) {
        return;
    }
    const slides = slider.querySelectorAll('.slide');
    const totalSlides = slides.length;
    let currentSlide = 0;
    // Update slide indicator
    function updateSlideIndicator() {
        if (currentSlideSpan) {
            currentSlideSpan.textContent = (currentSlide + 1).toString();
        }
    }
    // Show specific slide using transform
    function showSlide(index) {
        // Calculate the transform value
        const translateX = -index * 100;
        // Apply transform to the slider container
        slider.style.transform = `translateX(${translateX}%)`;
        // Update slide indicator
        updateSlideIndicator();
        // Update button states
        updateButtonStates();
    }
    // Update button states
    function updateButtonStates() {
        if (prevButton && nextButton) {
            prevButton.disabled = currentSlide === 0;
            nextButton.disabled = currentSlide === totalSlides - 1;
        }
    }
    // Go to next slide
    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            currentSlide++;
            showSlide(currentSlide);
        }
    }
    // Go to previous slide
    function prevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            showSlide(currentSlide);
        }
    }
    // Event listeners
    nextButton.addEventListener('click', nextSlide);
    prevButton.addEventListener('click', prevSlide);
    // Touch/swipe support
    let startX = 0;
    let endX = 0;
    slider.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
    });
    slider.addEventListener('touchend', function (e) {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
    });
    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = startX - endX;
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                // Swiped left - next slide
                nextSlide();
            }
            else {
                // Swiped right - previous slide
                prevSlide();
            }
        }
    }
    // Initialize
    showSlide(currentSlide);
});
